export const GetTrainTransferOrderSubmit = {
  //获取中转火车票信息
  module: 'b2b',
  address: 'TrainTicket/GetTrainTransferOrderSubmit',
};

export const CheckTrainTransferStandard = {
  //验证中转火车票差标
  module: 'b2b',
  address: 'TrainTicket/CheckTrainTransferStandard',
};

// 验证12306乘客信息
export const Check12306Passenger = {
  module: 'b2b',
  address: 'Customer/Check12306Passenger',
};

export const CreateTrainTransferOrder = {
  //创建中转火车票订单
  module: 'b2b',
  address: 'TrainTicket/CreateTrainTransferOrder',
};

export const GetStopStations = {
  // 获取停靠站点
  module: 'b2b',
  method: 'POST',
  address: 'TrainTicket/GetStopStations',
};
//获取上一单购票方式
export const ValidateLastTrainOrderUserType = {
  module: 'b2b',
  method: 'POST',
  address: 'TrainTicket/ValidateLastTrainOrderUserType',
};
//常用进入填单页获取火车票信息
export const GetTrainOrderSubmitForCommonlyUsed = {
  module: 'b2b',
  method: 'POST',
  address: 'TrainTicket/GetTrainOrderSubmitForCommonlyUsed',
};
// 获取中转列表
export const SearchTransferTrains = {
  module: 'b2b',
  method: 'POST',
  address: 'TrainTicket/SearchTransferTrains',
};
